(ns app.strive-forms.responses-preview
  (:require
   [app.components.icons.views :refer [chevron-down-icon]]
   [app.strive-forms.components :refer [gap-space progress-bar-componenet]]
   [app.strive-forms.defaults :refer [default-values]]
   [app.strive-forms.helper-functions :refer [get-question-title-in-html]]
   [app.strive-forms.styles :refer [first-question-response-skeleton
                                    first-question-title-skeleton preview-panel-answer-span
                                    preview-question-title progress-bar-close-button-style question-response-skeleton question-title-skeleton page-title-link]]
   [goog.string.format]
   [moment]
   [re-com.buttons :refer [hyperlink]]
   [re-com.core :as re-com :refer [at  gap v-box]]
   [reagent.core  :as r]))


(defn preview-group-title [theme-data selected-language grouped-value grouped-display-fields current-page language-direction]
  (let [page-index (.indexOf grouped-display-fields (some #(when (= (first grouped-value) (:group_id %)) %) grouped-display-fields))
        page-title (:page_title (first (second grouped-value)))]
    [hyperlink
     :label ((keyword selected-language) page-title)
     :parts {:wrapper {:class (page-title-link)}}
     :style {:font-size "14px"
             :font-weight "bold"
             :width "100%"
             :text-align (if (= "RTL" language-direction) "right" "left")
             :color (:buttons_color theme-data (:primary (:themes default-values)))}
     :on-click #(reset! current-page page-index)]))

(defn- preview-question-view [language-direction theme-data value selected-language hidden-fields display-fields form-messages current-page grouped-value grouped-display-fields]
  (let [page-index (.indexOf grouped-display-fields (some #(when (= (first grouped-value) (:group_id %)) %) grouped-display-fields))]
    [v-box
     :gap "3px"
     :style {:text-align (if (= "RTL" language-direction) "right" "left")
             :cursor "pointer"}
     :attr {:on-click #(reset! current-page page-index)}
     :children [[:div {:class (preview-question-title (:descriptons_color theme-data
                                                                          (:dark-gray (:themes default-values))))
                       :id (str "preview-question-field-" (:field_id value))
                       :dangerouslySetInnerHTML {:__html  (get-question-title-in-html
                                                           ((keyword selected-language) (:field_html value))
                                                           hidden-fields display-fields selected-language)}}]
                (case (:input_type value)
                  "boolean" (if (= (:value value) (:boolean-true-value default-values))
                              [:span (:yes_button_text form-messages)]
                              [:span (:no_button_text form-messages)])

                  "multi_select" (map (fn [multi-select-value]
                                        [:span multi-select-value])
                                      (:value value))
                  [:span {:class (preview-panel-answer-span)} (if (= "-1" (:value value)) "N/A" (:value value))])
                [gap  :size "15px"]]]))

(defn preview-filled-questions [theme-data selected-language hidden-fields display-fields form-messages questions-filled language-direction grouped-display-fields current-page]
  (->> questions-filled
       (group-by :group_id)
       (map (fn [grouped-value]
              [v-box
               :gap "15px"
               :children [(when (some? (:page_title (first (second grouped-value))))
                            (preview-group-title theme-data selected-language grouped-value grouped-display-fields current-page language-direction))
                          (map
                           (fn [value]
                             ^{:key (str "preview-question-field-" (:field_id value))}
                             (preview-question-view language-direction theme-data value selected-language hidden-fields display-fields form-messages current-page grouped-value grouped-display-fields))
                           (second grouped-value))]]))))

(defn unfilled-questions-skeleton [display-fields questions-filled theme-data]
  (let [fields-count (if (and (= "welcome_screen" (:type (first display-fields)))
                              (= "thank_you_screen" (:type (last display-fields))))
                       (- (count display-fields) 2)
                       (count display-fields))]
    (for [x (range (- fields-count (count questions-filled)))]
      [:div
       {:style {:margin-bottom "40px"}
        :key  (str "unfilled-preview-question-field-" x)}
       [:div
        {:class (if (= x 0)
                  (first-question-title-skeleton (str (:buttons_color theme-data (:primary (:themes default-values))) "5c"))
                  (question-title-skeleton (str (:answers_border_color theme-data) "61")))}]
       [:div
        {:class (if (= x 0)
                  (first-question-response-skeleton (str (:buttons_color theme-data (:primary (:themes default-values))) "ad"))
                  (question-response-skeleton (str (:answers_border_color theme-data) "9e")))}]])))
(defn responses-preview []
  (fn [{:keys [display-fields input-data selected-language theme-data hidden-fields form-messages language-direction is-drawer open-drawer grouped-display-fields current-page]}]
    (let [filled-values-from-input-data (vals (into {} (map
                                                        (fn [[key input-data-value]]
                                                          (when (and (some? (:value input-data-value)) (some #(= (name key) (:id %)) display-fields))
                                                            {key input-data-value})) input-data)))
          questions-filled (sort-by :item_order filled-values-from-input-data)
          progress (r/atom (* (/ (count questions-filled) (if (and (= "welcome_screen" (:type (first display-fields)))
                                                                   (= "thank_you_screen" (:type (last display-fields))))
                                                            (- (count display-fields) 2)
                                                            (count display-fields))) 100))]
      (when (and (some? (.getElementById js/document (str "preview-question-field-" (:field_id (first (take-last 2 questions-filled)))))) (> (count questions-filled) 5))
        (.scrollIntoView (.getElementById js/document (str "preview-question-field-" (:field_id (first (take-last 2 questions-filled)))))
                         (clj->js {:block "center" :inline "center" :behavior "auto"})))
      [v-box
       :src (at)
       :width "90%"
       ;:style {:overflow "hidden"}
       :padding "20px"
       :children [(when (> (.-innerWidth js/window) 1100)
                    [gap-space {:primary-gap (:languages-to-header-gap (:gaps-primary default-values))
                                :secondary-gap (:languages-to-header-gap (:gaps-mobile-view default-values))}])
                  (when (< (.-innerWidth js/window) 1100) [:div {:class (progress-bar-close-button-style)
                                                                 :on-click #(reset! open-drawer false)}
                                                           [chevron-down-icon {:size "24px"}]])
                  [progress-bar-componenet {:theme-data theme-data :progress progress :is-mobile false :is-drawer is-drawer}]
                  (if (> (.-innerWidth js/window) 1100)
                    [gap :size "48px"]
                    [gap :size "20px"])
                  [v-box
                   :style {:height (if  (> (.-innerWidth js/window) 1100) "75vh" "60vh")
                           :overflow-y "auto"
                           :padding "0px 15px"
                           :text-align (if (= "RTL" language-direction) "-webkit-right" "-webkit-left")}
                   :children [(preview-filled-questions theme-data selected-language hidden-fields display-fields form-messages questions-filled
                                                        language-direction grouped-display-fields current-page)
                              (unfilled-questions-skeleton display-fields questions-filled theme-data)]]]])))

(defn mobile-progress-bar []
  (fn [{:keys [display-fields input-data theme-data open-drawer]}]
    (let [filled-values-from-input-data
          (vals (into {} (map
                          (fn [[key input-data-value]]
                            (when (some? (:value input-data-value))
                              {key input-data-value})) input-data)))
          questions-filled (sort-by :item_order filled-values-from-input-data)
          progress (r/atom (* (/ (count questions-filled) (if (and (= "welcome_screen" (:type (first display-fields)))
                                                                   (= "thank_you_screen" (:type (last display-fields))))
                                                            (- (count display-fields) 2)
                                                            (count display-fields))) 100))]
      [:div
       {:style {:margin "0px 20px"}
        :on-click  #(reset! open-drawer true)}
       [progress-bar-componenet {:theme-data theme-data :progress progress :is-mobile true :is-drawer true
                                 :open-drawer @open-drawer}]])))